import TokensList from './TokensList';

export default TokensList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/TokensList/index.js